var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPasswordSuccess = function SvgPasswordSuccess(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13,
    height: 8,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#269636",
    fillRule: "evenodd",
    d: "M11.784.212a15.36 15.36 0 0 0-6.74 4.567C3.877 3.767 2.661 3.187 1.142 2.92c-.587-.104-.892.675-.39.997A11 11 0 0 1 4.13 7.273c.47.724 1.526.732 2.008.017a21.9 21.9 0 0 1 6.124-6.108c.53-.355.125-1.175-.479-.97",
    clipRule: "evenodd"
  })));
};
export default SvgPasswordSuccess;